import { render } from "./VersesQuotes.vue?vue&type=template&id=eb2cee2c"
import script from "./VersesQuotes.vue?vue&type=script&lang=js"
export * from "./VersesQuotes.vue?vue&type=script&lang=js"

import "./VersesQuotes.vue?vue&type=style&index=0&id=eb2cee2c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__